module.exports = {"TXTCLI_Coming_soonX_1":{"id":"TXTCLI_Coming_soonX_1","defaultMessage":"¡Próximamente!"}}